import { css } from 'linaria';

export const categoryCardSlide = css`
  && {
    width: 176px;
    height: 240px;
    margin-right: 24px;

    @media (--only-desktop) {
      width: 169px;
    }
  }
`;
